export default "__VITE_ASSET__CW11pVpe__"